const MAX_PAGES = 10;

export async function fetchAllPages<T>(
  limit: number,
  fetchPage: (offset: number, limit: number) => Promise<{ items: T[]; total: number }>,
): Promise<T[]> {
  const items: T[] = [];

  for (let page = 0; page < MAX_PAGES; page++) {
    const result = await fetchPage(page * limit, limit);
    items.push(...result.items);

    if (items.length >= result.total || result.items.length < limit) break;
  }

  return items;
}
